export function kFormatter(num: number) {
  return Math.abs(num) > 1999
    ? `${Math.sign(num) * parseFloat((Math.abs(num) / 1000).toFixed(1))}K`
    : (Math.sign(num) * Math.abs(num)).toFixed();
}
